export default "__VITE_ASSET__CLC4lOHf__"